// client/src/hooks/issueTriage/useBugReportShortcut.ts
import { useEffect, useCallback, useState } from 'react';

/**
 * Hook to handle Ctrl/Cmd + Shift + B shortcut for bug reporting
 *
 * @example
 * ```tsx
 * const { isWidgetOpen, openWidget, closeWidget } = useBugReportShortcut();
 * ```
 */
export function useBugReportShortcut() {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);

  const openWidget = useCallback(() => {
    setIsWidgetOpen(true);
  }, []);

  const closeWidget = useCallback(() => {
    setIsWidgetOpen(false);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl/Cmd + Shift + B
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key.toLowerCase() === 'b') {
        e.preventDefault();
        setIsWidgetOpen(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return {
    isWidgetOpen,
    openWidget,
    closeWidget,
  };
}
